import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import Link from '../Link/Link.js';

const LinkGroup = ({ className , links  })=>{
    if (!(links === null || links === void 0 ? void 0 : links.length)) return null;
    return /*#__PURE__*/ React.createElement("ul", {
        className: classnames('link-group', className)
    }, links.map((_param)=> {
        var { icon , label , url  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
            "icon",
            "label",
            "url"
        ]);
        return React.createElement("li", {
            key: label,
            className: "link-group__item"
        }, /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({
            url: url,
            className: "link-group__link"
        }, rest), icon && /*#__PURE__*/ React.createElement(Icon, {
            className: "link-group__icon",
            name: icon,
            width: 32,
            height: 32
        }), /*#__PURE__*/ React.createElement(Text, {
            className: "link-group__text",
            component: "span"
        }, label), /*#__PURE__*/ React.createElement(Icon, {
            className: "link-group__icon link-group__icon--arrow",
            name: "chevron-right"
        })));
    }));
};
var LinkGroup$1 = LinkGroup;

export { LinkGroup$1 as default };
//# sourceMappingURL=LinkGroup.js.map
